import React, { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface RouterLinkProps extends LinkProps {
  href: string;
}

const RouterLink = forwardRef<any, RouterLinkProps>(({ href, ...other }, ref) => (
  <Link ref={ref} {...other} to={href} />
));

export default RouterLink;
